/// <amd-module name="Artifacts/Root/protocols/components/ProtocolProvider" />
import { useProtocol } from "Artifacts/Root/Protocols/hooks/Protocol";
import { IProtocol } from "Artifacts/Root/protocols/types";
import { IPackage } from "Artifacts/Root/types";
import * as React from "react";

export interface IProtocolProviderProps {
  pkg: IPackage;
  children: (protocol: IProtocol) => React.ReactElement;
}

/**
 * ProtocolProvider is a render prop component that provides protocol object
 * based on provided package.
 */
const ProtocolProvider: React.FC<IProtocolProviderProps> = ({ children, pkg }) => {
  const protocol = useProtocol(pkg);

  if (protocol == null) {
    throw new Error(`Unable to resolve protocol for package ${pkg?.name}`);
  }
  return children(protocol);
};

export { ProtocolProvider };
